const MAX_TRIES = 3;
const TIMEOUT_INTERVAL = 250;
const OVER_QUERY_LIMIT = 'OVER_QUERY_LIMIT';
const OK = 'OK';
const ZERO_RESULTS = 'ZERO_RESULTS';
const GOOGLE_DIRECTIONS_URL = 'https://www.google.com/maps/dir/?api=1';
const GOOGLE_SEARCH_URL = 'https://www.google.com/maps/search/?api=1';
const ADMIN_AREA_LEVEL_ONE = 'administrative_area_level_1';
const COUNTRY = 'country';
const FILTERABLE_COUNTRY_LIST = ['USA', 'United States'];

export {
    ADMIN_AREA_LEVEL_ONE,
    COUNTRY,
    FILTERABLE_COUNTRY_LIST,
    GOOGLE_DIRECTIONS_URL,
    GOOGLE_SEARCH_URL,
    MAX_TRIES,
    OK,
    OVER_QUERY_LIMIT,
    TIMEOUT_INTERVAL,
    ZERO_RESULTS,
};

export default {
    OK,
    OVER_QUERY_LIMIT,
    MAX_TRIES,
    TIMEOUT_INTERVAL,
    ZERO_RESULTS,
    GOOGLE_DIRECTIONS_URL,
    GOOGLE_SEARCH_URL,
    ADMIN_AREA_LEVEL_ONE,
    COUNTRY,
    FILTERABLE_COUNTRY_LIST,
};
